<template>
  <v-snackbar
    v-model="config.visible"
    :timeout="config.timeout"
    :color="config.type ? config.type : 'info'"
    rounded="pill"
     min-width="50%"
  > 
     <span class="">{{ config.text }}</span>
    <v-icon class="px-2" v-if="config.type === 'success'">mdi-check-circle</v-icon>
    <v-icon class="px-2" v-if="config.type === 'error'">mdi-close</v-icon>
    <v-icon class="px-2" v-if="config.type === 'info'">mdi-information-outline</v-icon>
 
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("alerts", ["config"]),
  },
};
</script>
